import hmacSha256 from "crypto-js/hmac-sha256";
import Hex from "crypto-js/enc-hex";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";

import { IMGPROXY_KEY, IMGPROXY_SALT } from "./imgproxy-config";
import { convertBase64ToUrlSafe } from "../crypto";

export const hexDecode = (hex: string) => Hex.parse(hex).toString(Utf8);

const SALT = hexDecode(IMGPROXY_SALT);
const KEY = Utf8.parse(hexDecode(IMGPROXY_KEY));

export const imgproxySign = (target: string) => {
  const hmac = hmacSha256(Utf8.parse(`${SALT}${target}`), KEY);

  return convertBase64ToUrlSafe(hmac.toString(Base64));
};
